(function () {
  if (window.__lumenReserve) return;
  window.__lumenReserve = true;
  var KEY = 'lumen_reserve_end';
  // Per sessie (tabblad): elke nieuwe sessie begint weer op de volledige tijd. Oude waarde uit localStorage opruimen.
  try { localStorage.removeItem(KEY); } catch (e) {}
  function read() { try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return 0; } }
  function write(v) { try { if (v) sessionStorage.setItem(KEY, String(v)); else sessionStorage.removeItem(KEY); } catch (e) {} }
  function fmt(ms) {
    var s = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(s / 60);
    s = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
  }
  function fit(box) {
    box.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(box).fontSize) || 13;
    while (box.scrollWidth > box.clientWidth + 1 && size > 9) {
      size -= 0.5;
      box.style.fontSize = size + 'px';
    }
    box.setAttribute('data-fit', '1');
  }
  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-lumen-reserve]').forEach(fit);
  });
  function tick() {
    var boxes = document.querySelectorAll('[data-lumen-reserve]');
    if (!boxes.length) {
      if (document.querySelector('cart-drawer.is-empty')) write(0);
      return;
    }
    var mins = parseInt(boxes[0].getAttribute('data-minutes'), 10) || 5;
    var now = Date.now();
    var end = read();
    // nieuwe timer bij eerste product (of kortere ingestelde duur); na afloop blijft hij op 00:00 staan
    if (!end || end - now > mins * 60000) {
      end = now + mins * 60000;
      write(end);
    }
    var text = fmt(end - now);
    boxes.forEach(function (box) {
      var t = box.querySelector('[data-lumen-reserve-time]');
      if (t) t.textContent = text;
      if (!box.getAttribute('data-fit')) fit(box);
    });
  }
  setInterval(tick, 1000);
  document.addEventListener('DOMContentLoaded', tick);
  tick();
})();
